import { StoreType } from '@tock/shared/utils/connect';
import { filter, uniqBy } from 'es-toolkit/compat';

export const getPaymentCard = (state: StoreType) => state.paymentCard;
export const getCards = (state: StoreType) => {
  return {
    cards: uniqBy(filter(state.paymentCard.cards), 'storedToken'),
    isRequesting: state.paymentCard.listRequestInProgress,
    isInitialized: state.paymentCard.isInitialized,
  };
};
export const getDeviceData = (state: StoreType) => state.paymentCard.deviceData;
